import { useState } from "react";
import { clearLocalMeals, loadLocalMeals, saveMealRemote } from "../lib/storage";

interface Props {
  onDone: () => void;
}

export default function MigrationBanner({ onDone }: Props) {
  const local = loadLocalMeals();
  const [status, setStatus] = useState<"idle" | "importing" | "done" | "error">("idle");
  const [error, setError] = useState<string | null>(null);
  const [progress, setProgress] = useState(0);

  if (local.length === 0 || status === "done") return null;

  async function importAll() {
    setStatus("importing");
    setError(null);
    try {
      for (let i = 0; i < local.length; i++) {
        const m = local[i];
        await saveMealRemote({
          meal_type: m.meal_type,
          logged_at: m.logged_at,
          estimate: m.estimate,
          caption: m.caption,
          source_providers: m.source_providers,
          disagreement_pct: m.disagreement_pct,
          imageDataUrl: m.photo_data_url
        });
        setProgress(i + 1);
      }
      clearLocalMeals();
      setStatus("done");
      onDone();
    } catch (err) {
      setError((err as Error)?.message ?? String(err));
      setStatus("error");
    }
  }

  function discard() {
    clearLocalMeals();
    setStatus("done");
    onDone();
  }

  return (
    <div className="mx-4 mt-4 p-3 rounded-lg bg-amber-950 border border-amber-800 text-amber-100 space-y-2">
      <div className="text-sm font-semibold">
        {local.length} meal{local.length === 1 ? "" : "s"} found on this device
      </div>
      <div className="text-xs text-amber-200/80">
        Import them to your account so they sync across devices?
      </div>
      {status === "importing" && (
        <div className="text-xs">Importing… {progress} / {local.length}</div>
      )}
      {error && <div className="text-xs text-red-300">{error}</div>}
      <div className="flex gap-2 pt-1">
        <button
          onClick={importAll}
          disabled={status === "importing"}
          className="flex-1 py-2 rounded bg-emerald-500 text-slate-950 text-sm font-medium disabled:opacity-60"
        >
          {status === "importing" ? "Importing…" : "Import"}
        </button>
        <button
          onClick={discard}
          disabled={status === "importing"}
          className="px-3 py-2 rounded border border-amber-700 text-amber-200 text-sm disabled:opacity-60"
        >
          Discard
        </button>
      </div>
    </div>
  );
}
